import React, { createContext, useContext, useReducer, useMemo, useCallback } from 'react'
import { ethers, constants } from 'ethers'
import { getTokenReserves, getMarketDetails, BigNumber } from '@uniswap/sdk'
import { useWeb3Context } from 'web3-react'
import { aggregate } from '@makerdao/multicall';
import { safeAccess, isAddress, getEtherBalance, getTokenBalance, b } from '../utils'
import { useAllTokenDetails } from './Tokens'
import { MULTICALL_ADDRESS, BASE } from '../constants'

const ZERO = ethers.utils.bigNumberify(0)
const ONE = new BigNumber(1)

const UPDATE = 'UPDATE'

const AllBalancesContext = createContext()

function useAllBalancesContext() {
  return useContext(AllBalancesContext)
}

function reducer(state, { type, payload }) {
  switch (type) {
    case UPDATE: {
      const { allBalanceData, networkId, address } = payload
      return {
        ...state,
        [networkId]: {
          ...(safeAccess(state, [networkId]) || {}),
          [address]: {
            ...(safeAccess(state, [networkId, address]) || {}),
            allBalanceData
          }
        }
      }
    }
    default: {
      throw Error(`Unexpected action type in AllBalancesContext reducer: '${type}'.`)
    }
  }
}

function getExchangeRate(inputValue, inputDecimals, outputValue, outputDecimals, invert = false, baseFactor = b(1)) {
  try {
    if (
      inputValue &&
      (inputDecimals || inputDecimals === 0) &&
      outputValue &&
      (outputDecimals || outputDecimals === 0)
    ) {
      const factor = b(10).pow(b(18)).mul(baseFactor)

      if (invert) {
        return inputValue
          .mul(factor)
          .div(outputValue)
          .mul(b(10).pow(b(outputDecimals)))
          .div(b(10).pow(b(inputDecimals)))
      } else {
        return outputValue
          .mul(factor)
          .div(inputValue)
          .mul(b(10).pow(b(inputDecimals)))
          .div(b(10).pow(b(outputDecimals)))
      }
    }
  } catch { }
}

function getMarketRate(
  swapType,
  inputReserveETH,
  inputReserveToken,
  inputDefReserveBase,
  inputDefReserveToken,
  inputDecimals,
  outputReserveETH,
  outputReserveToken,
  outputDefReserveBase,
  outputDefReserveToken,
  outputDecimals,
  bridgeReserveToken,
  bridgeReserveETH
) {
  const baseFactor = b(10).pow(b(18))
  //   if (swapType === ETH_TO_TOKEN) {
  //     return getExchangeRate(outputReserveETH, 18, outputReserveToken, outputDecimals, invert, baseFactor)
  //   } else if (swapType === TOKEN_TO_ETH) {
  // return getExchangeRate(inputReserveToken, inputDecimals, inputReserveETH, 18, invert, baseFactor)
  //   } else if (swapType === TOKEN_TO_TOKEN) {
  // TODO! Try this one
  // const firstRate = getExchangeRate(inputReserveToken, inputDecimals, inputReserveETH, 18, false, baseFactor)
  // const secondRate = getExchangeRate(outputReserveETH, 18, outputReserveToken, outputDecimals, false, baseFactor)
  // try {
  //   return !!(firstRate && secondRate) ? firstRate.mul(secondRate).div(baseFactor).div(baseFactor) : undefined
  // } catch { }
  //   } else if (swapType === BASE_TO_DEFTOKEN) {
  //     return getExchangeRate(outputDefReserveBase, 18, outputDefReserveToken, outputDecimals, invert, baseFactor)
  //   } else if (swapType === DEFTOKEN_TO_BASE) {
  //     return getExchangeRate(inputDefReserveToken, inputDecimals, inputDefReserveBase, 18, invert, baseFactor)
  //   } else if (swapType === ETH_TO_DEFTOKEN) {
  //     const firstRate = getExchangeRate(bridgeReserveToken, 18, bridgeReserveETH, 18, baseFactor)
  //     const secondRate = getExchangeRate(outputDefReserveBase, 18, outputDefReserveToken, outputDecimals, invert, baseFactor)
  //     try {
  //       return !!(firstRate && secondRate) ? firstRate.mul(secondRate).div(baseFactor) : undefined
  //     } catch {}
  //   } else if (swapType === DEFTOKEN_TO_ETH) {
  //     const firstRate = getExchangeRate(inputDefReserveToken, inputDecimals, inputDefReserveBase, 18, invert, baseFactor)
  //     const secondRate = getExchangeRate(bridgeReserveToken, 18, bridgeReserveETH, 18, invert, b(1)) // TODO Why 1 and not baseFactor?
  //     try {
  //       return !!(firstRate && secondRate) ? secondRate.mul(firstRate).div(baseFactor) : undefined
  //     } catch {}
  //   } else if (swapType === TOKEN_TO_DEFTOKEN) {
  //     const firstRate = getExchangeRate(inputReserveToken, inputDecimals, inputReserveETH, 18, invert, b(1))
  //     const secondRate = getExchangeRate(bridgeReserveToken, 18, bridgeReserveETH, 18, baseFactor)
  //     const thirdRate = getExchangeRate(outputDefReserveBase, 18, outputDefReserveToken, outputDecimals, invert, baseFactor)
  //     try {
  //       return !!(firstRate && secondRate) ? firstRate.mul(secondRate).mul(thirdRate).div(baseFactor).div(baseFactor) : undefined
  //     } catch {}
  //   } else if (swapType === DEFTOKEN_TO_TOKEN) {
  //     const firstRate = getExchangeRate(inputDefReserveToken, inputDecimals, inputDefReserveBase, 18, invert, baseFactor)
  //     const secondRate = getExchangeRate(bridgeReserveToken, 18, bridgeReserveETH, 18, invert, b(1))
  //     const thirdRate = getExchangeRate(outputReserveETH, 18, outputReserveToken, outputDecimals, invert, b(1))
  //     try {
  //       return !!(firstRate && secondRate) ? firstRate.mul(secondRate).mul(thirdRate).div(baseFactor).div(baseFactor) : undefined
  //     } catch {}
  //   } else if (swapType === DEFTOKEN_TO_DEFTOKEN) {
  //     const firstRate = getExchangeRate(inputDefReserveToken, inputDecimals, inputDefReserveBase, 18, invert, baseFactor)
  //     const secondRate = getExchangeRate(outputDefReserveBase, 18, outputDefReserveToken, outputDecimals, invert, baseFactor)
  //     try {
  //       return !!(firstRate && secondRate) ? firstRate.mul(secondRate).div(baseFactor).div(baseFactor) : undefined
  //     } catch {}
  //   }
}

export default function Provider({ children }) {
  const [state, dispatch] = useReducer(reducer, {})

  const update = useCallback((allBalanceData, networkId, address) => {
    dispatch({ type: UPDATE, payload: { allBalanceData, networkId, address } })
  }, [])

  return (
    <AllBalancesContext.Provider value={useMemo(() => [state, { update }], [state, update])}>
      {children}
    </AllBalancesContext.Provider>
  )
}

export function useFetchAllBalances() {
  const { account, networkId, library } = useWeb3Context()

  const allTokens = useAllTokenDetails()

  const [state, { update }] = useAllBalancesContext()

  const { allBalanceData } = safeAccess(state, [networkId, account]) || {}

  const getData = async () => {
    if (!!library && !!account) {
      const newBalances = {}

      const multicallConfig = {
        multicallAddress: MULTICALL_ADDRESS[1],
        rpcUrl: process.env.REACT_APP_NETWORK_URL // Needs a configured node to work
      };

      let tmp = await aggregate(
        Object.keys(allTokens).map(k => {
          if (k !== 'ETH') {
            return {
              target: k,
              call: ['balanceOf(address)(uint256)', account],
              returns: [[`${k}_bl`]]
            }
          } else {
            return {
              call: [
                'getEthBalance(address)(uint256)',
                account
              ],
              returns: [[`${k}_bl`]]
            }
          }
        }),
        multicallConfig
      )

      Object.keys(allTokens).forEach(t => {
        const balance = tmp.results[`${t}_bl`]
        const ethRate = t === "ETH" ? ONE : undefined
        newBalances[t] = { balance, ethRate }
      })


      tmp = []
      Object.keys(allTokens).filter(
        t => t === 'ETH' ||
          t.toLowerCase() === BASE[1].toLowerCase() ||
          newBalances[t].balance.gt(ZERO)
      ).forEach((t) => {
        // Get Token reserves
        const exchange = allTokens[t].exchangeAddress;
        if (exchange) {
          tmp.push(
            {
              call: [
                'getEthBalance(address)(uint256)',
                exchange
              ],
              returns: [[`${t}_eeb`]]
            }
          )
          tmp.push(
            {
              target: t,
              call: ['balanceOf(address)(uint256)', exchange],
              returns: [[`${t}_etb`]]
            }
          )
        }
        const defex = allTokens[t].defexAddress;
        if (defex) {
          tmp.push(
            {
              target: t,
              call: ['balanceOf(address)(uint256)', defex],
              returns: [[`${t}_detb`]]
            }
          )
          tmp.push(
            {
              target: BASE[1],
              call: ['balanceOf(address)(uint256)', defex],
              returns: [[`${t}_debb`]]
            }
          )
        }
      })

      tmp = await aggregate(tmp, multicallConfig);
      Object.keys(allTokens).filter(t => t === 'ETH' || newBalances[t].balance.gt(ZERO)).forEach((t) => {
        const inputTokenReserve = tmp.results[`${t}_etb`]
        const inputEthReserve = tmp.results[`${t}_eeb`]
        const inputDefexTokenReserve = tmp.results[`${t}_detb`]
        const inputDefexBaseReserve = tmp.results[`${t}_debb`]

        if (inputTokenReserve && inputEthReserve) {
          const rateRaw = new BigNumber(getExchangeRate(inputTokenReserve, allTokens[t].decimals, inputEthReserve, 18, false))
          const ethRate = rateRaw.div(b(10).pow(b(18)))
          newBalances[t].ethRate = ethRate
        } else if (inputDefexTokenReserve && inputDefexBaseReserve) {
          const bridgeTokenReserve = tmp.results[`${BASE[1]}_etb`]
          const bridgeEthReserve = tmp.results[`${BASE[1]}_eeb`]
          const rateToBridge = new BigNumber(getExchangeRate(bridgeTokenReserve, 18, bridgeEthReserve, 18, false))
          const rateOnDefex = new BigNumber(getExchangeRate(inputDefexTokenReserve, allTokens[t].decimals, inputDefexBaseReserve, 18, false))
          const ethRate = rateOnDefex.multipliedBy(rateToBridge).dividedBy(b(10).pow(b(18))).dividedBy(b(10).pow(b(18)))
          newBalances[t].ethRate = ethRate
        }
      })

      update(newBalances, networkId, account)
    }
  }

  useMemo(getData, [account])

  return allBalanceData
}
